
import { debounce } from "debounce";
export default {
  name: "elasticFilters",
  data() {
    return {
      more: {},
      moreInput: {},
      debounce,
      open: false,
      priceRange: { min: 0, max: 0, from: 0, to: 0, ready: false },
      filters: {
        business_activity: [{}],
      },
      lock: false,
    };
  },
  watch: {
    open: function (v) {
      if (v) {
        // document.querySelector("body").classList.add("overflow-hidden");
      } else {
        // document.querySelector("body").classList.remove("overflow-hidden");
      }
    },
    "$store.state.catalogue": {
      handler(v) {
        this.createPriceRange();
      },
      deep: true,
    },
  },
  mounted() {
    this.$nuxt.$on("filterToggle", (v) => {
      this.open = !this.open;
    });
    this.createPriceRange();
  },
  methods: {
    isChecked(c, k) {
      let checked = false;
      if (
        c.key.includes("tag.") &&
        !this.$store.getters.store.eshop.tagsMultiple
      ) {
        return (
          (this.$store.getters.filters.tags || "") ==
          (k.key || "").split(" | ")[0]
        );
      } else {
        let key = (k.key || "").split(" | ")[0];
        let slug = (k.slug || "").split(" | ")[0];
        if (c.key.includes("tag.")) {
          let extra = `tag.${this.$hyperUtility.slugifyGreek(
            c.key.replace().replace("tag.", "")
          )}`;
          return (
            (this.$store.getters.filters[c.key] || "") == key ||
            (this.$store.getters.filters[extra] || "").includes(slug)
          );
        }
        checked = (this.$store.getters.filters[c.key] || "").includes(key);
      }
      return checked;
    },
    showLess(k) {
      delete this.more[k];
      delete this.moreInput[k];
      this.$forceUpdate();
    },
    async fetchMore(k) {
      let t = await this.$store.dispatch("filters", {
        size: 1000,
        aggs: [k],
        partial: true,
      });
      this.more[k] = t[k].filter((x) => x.key);
      this.moreInput[k] = "";
      this.$forceUpdate();
    },
    pricesChanges() {
      if (this.lock) {
        return;
      }
      this.lock = true;
      // this.priceRange.ready = false;
      let self = this;
      self.$router.push(
        self.$hyperUtility.urlElasticCreator(
          "price",
          `${self.priceRange.from}-${self.priceRange.to}`
        )
      );
    },
    createPriceRange() {
      if (!Array.isArray(this.$store.getters.catalogue)) {
        return;
      }
      let prices = (
        (this.$store.getters.catalogue.find((e) => e.key == "prices") || {})
          .prices || []
      ).map((e) => e.key);
      if (prices) {
        this.priceRange.min = Math.min(...prices);
        this.priceRange.max = Math.max(...prices);
        let f = this.$store.getters.filters.price || false;
        let from,
          to = 0;
        if (f) {
          f = f.split("-");
          from = parseInt(f[0]);
          to = parseInt(f[1]);
        }
        this.priceRange.from =
          (from || Math.min(...prices)) - 1 < 0
            ? 0
            : (from || Math.min(...prices)) - 1;
        this.priceRange.to = (to || Math.max(...prices)) + 1;
      }
      this.priceRange.ready = true;
    },
  },
};
